export interface IAppState {
  userDetails: object;
  userToken: Object,
  guestToken: Object,
  isUserLogin: boolean,
  familydetails: Object,
  whatsappOptInState: number,
  subscriptionData: Object,
  walletDetails: Object,
  reviews: any[],
  isProfileComplete: boolean,
  aayuPlans: any[],
  aayuAllPlans: any[],
  premiumAayuCard: Object,
  consultationParams: Object,
  currentConsultationQuestion: Object,
  currentConsultationAnswer: Object,
  consultationQuestion: any[],
  consultationAnswer: Object,
  renderQuestionElement: boolean,
  consultImageData: Object,
  eConsultInfo: Object,
  selectedAayucard: Object,
  addUpdateScreenData: Object,
  isDashboardLoaded: boolean,
  userLoginDetails: Object,
  consultationList: any[] | null,
  orderList: any,
  selectedLocation: any,
  previousSelectedLocation: any[],
  previousSelectedMedicineCategory: any[],
  previousSelectedMedicine: any[],
  cartItemsData: any,
  cartImagesData: any,
  repeatOrderData: any,
  pharmacyAllData: Object,
  selectedStore: Object,
  downloadedChatImagesList: Object,
  orderInstructions: String,
  userVisitedStore: any[]
}

export const INITIAL_STATE: IAppState = {
  userDetails: {},
  userToken: {},
  guestToken: {},
  isUserLogin: false,
  familydetails: {},
  whatsappOptInState: 0,
  subscriptionData: {},
  walletDetails: {},
  reviews: [],
  isProfileComplete: false,
  aayuPlans: [],
  aayuAllPlans: [],
  premiumAayuCard: {},
  consultationParams: {},
  currentConsultationQuestion: {},
  currentConsultationAnswer: {},
  consultationQuestion: [],
  consultationAnswer: {},
  renderQuestionElement: false,
  consultImageData: {},
  eConsultInfo: {},
  selectedAayucard: {},
  addUpdateScreenData: {},
  isDashboardLoaded: false,
  userLoginDetails: {},
  consultationList: null,
  orderList: null,
  selectedLocation: null,
  previousSelectedLocation: [],
  previousSelectedMedicineCategory: [],
  previousSelectedMedicine: [],
  cartItemsData: null,
  cartImagesData: null,
  repeatOrderData: {},
  pharmacyAllData: {},
  selectedStore: {},
  downloadedChatImagesList: {},
  orderInstructions: '',
  userVisitedStore: []
};
